import { Component, input } from '@angular/core'
import { UseCaseInterface } from '@ui-features/help/interfaces/use-case.interface'

@Component({
    selector: 'app-use-case-card',
    imports: [],
    templateUrl: './use-case-card.html',
})
export class UseCaseCard {
    useCase = input<UseCaseInterface>()
}
